import { Section } from "@widgets/section";

import type { ArtSectionsSectionBase } from "@shared/content-types/schemas/sections.schema";
import type { ColorIconType } from "@shared/content-types/types";
import { Container } from "@shared/ui/container";
import { Body } from "@shared/ui/typography";

import type { ArtSectionType } from "../model";
import { FirstType } from "./first-type";
import { SecondType } from "./second-type";
import { ThirdType } from "./third-type";

import s from "./home-art-sections.module.scss";

const getSection = (data: ArtSectionType, pageIcon: ColorIconType) => {
  switch (data.variation) {
    case "three-images-bace":
      return (
        <FirstType
          key={`art_section-${data.variation}-${data.id}`}
          data={data}
          pageIcon={pageIcon}
        />
      );

    case "three-images-long":
      return (
        <SecondType
          key={`art_section-${data.variation}-${data.id}`}
          data={data}
          pageIcon={pageIcon}
        />
      );

    case "one-image":
      return (
        <ThirdType
          key={`art_section-${data.variation}-${data.id}`}
          data={data}
          pageIcon={pageIcon}
        />
      );

    default:
      break;
  }
};

export const HomeArtSections = (
  props: ArtSectionsSectionBase & { pageIcon: ColorIconType },
) => {
  const { subtitle, title, artSections, pageIcon } = props;

  return (
    <Section className={s.root}>
      <Container>
        <div className={s.top}>
          {subtitle && (
            <Body
              size="uppercase-small"
              weight="semiBold"
              className={s.subtitle}
            >
              {subtitle}
            </Body>
          )}
          {title && <p className={s.title}>{title}</p>}
        </div>
        <div className={s.sections}>
          {artSections &&
            artSections.length > 0 &&
            artSections.map((section) => getSection(section, pageIcon))}
        </div>
      </Container>
    </Section>
  );
};

HomeArtSections.displayName = "HomeArtSections";
